export default __webpack_public_path__ + "static/subscription-556469b783ac19e1e66ed387a5ed4b12.svg";